import { ChatPage } from "@/features/chat/pages/Chat";
import React from "react";

const Chat = () => {
  return <ChatPage />;
};

export default Chat;
